import { useTicketsStore } from "../../stores/ticketsStore"
import { N_CACHE_CONVERSAS_MS } from "../../constants/timing"

export const prefetchPacoteConversas = () => {
  import(/* webpackPrefetch: true */ "../../pages/TicketResponsiveContainer")
}

const chaveSessaoValida = (cChave) => cChave && cChave !== "null:null"

const sessaoInicialCoincide = (cChaveSessaoInicial, cChaveSessaoAtual) =>
  chaveSessaoValida(cChaveSessaoAtual) && cChaveSessaoInicial === cChaveSessaoAtual

const dadosAbertosRecentes = (oUltimaBuscaEm, mIdsAbertos) =>
  Boolean(oUltimaBuscaEm?.open) &&
  Date.now() - oUltimaBuscaEm.open < N_CACHE_CONVERSAS_MS &&
  mIdsAbertos.length > 0

const conversasJaCarregadas = (oEstado, lForcar) => {
  if (lForcar) return false

  const { lastFetchedAt, openIds, cChaveSessaoInicial, obterChaveSessaoInicial } = oEstado

  return (
    sessaoInicialCoincide(cChaveSessaoInicial, obterChaveSessaoInicial()) &&
    dadosAbertosRecentes(lastFetchedAt, openIds)
  )
}

const prefetchDadosConversas = (oParametros = {}, oOpcoes = {}) => {
  if (!localStorage.getItem("token")) return

  const oEstado = useTicketsStore.getState()
  if (conversasJaCarregadas(oEstado, Boolean(oOpcoes?.forcar))) return

  oEstado.ticketsInicialBuscar(oParametros, 1, { silencioso: true }).catch(() => {})
}

/** Prefetch do chunk + carga inicial quando o store ainda está vazio. */
export const prefetchConversasInicial = () => {
  prefetchPacoteConversas()
  prefetchDadosConversas()
}

/** Hover no menu: chunk + dados só se não houver cache recente. */
export const prefetchConversasCompleto = () => {
  prefetchConversasInicial()
}

/** Pós-login: sempre busca bootstrap antes de navegar para /conversas. */
export const prefetchConversasAposLogin = () => {
  prefetchPacoteConversas()
  prefetchDadosConversas({}, { forcar: true })
}
